import React, {useEffect} from 'react'
import {Card, CardBody, CardTitle} from 'reactstrap'
import { Trans } from "react-i18next"
import {generateBarLineChart} from '../../utils/graphs_facility'
import {find_evaluation, evaluation} from '../../config/evaluations'
export default ({score_distribution}) => {

    useEffect(() => {
	
	if(score_distribution != null){

	    score_distribution = score_distribution.concat(evaluation.map(e => score_distribution.findIndex(sd => sd.score === e.score) == -1 ? {score: e.score, companies: []} : null ).filter(x => x) )
	    
	    let chart = generateBarLineChart({id: 'score_distribution', data: score_distribution.sort((a,b) => a.score<b.score ?  1 : -1).map(x => {return {category: find_evaluation({score: x.score}).letter, count: x.companies}}), bar: [{title: '# di aziende', field: 'count'}], hide_legend: true})
	    return () => {
		if(chart)
		    chart.dispose()
	    }
	}

    })
    
    
    return (	    
	    <React.Fragment>

		<div id="score_distribution" style={{height: '400px'}}></div>
	    </React.Fragment>
    ) 
}
